// src/pages/BankWalaHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const BankWalaHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Self Assesment");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Self Assesment", emoji: "🙋‍♀️" },
    { label: "Productivity", emoji: "⚡" },
    { label: "FinEx", emoji: "📝" },    
    { label: "FINWISER", emoji: "👳" },
    { label: "FinTrust", emoji: "🛡️" },
    { label: "Processifyd", emoji: "⚙️" },
    { label: "Continous Banking Learning", emoji: "📚" },
    { label: "Micro-Earning", emoji: "💰" },
    { label: "Banker Self Reflection", emoji: "🪞" },
    { label: "Other Engagements", emoji: "🛍️" },
    { label: "BankWala AI", emoji: "👳" },    
  ];

  // FULL BankWala Menu Buttons
  const menuButtons1 = [
    // 🙋‍♀️ Self Assesment
    { label: "Self Assessment Sheet", emoji: "📝", link: "/bankwala-selfassessment", group: "Self Assesment" },
    { label: "Assessment Log", emoji: "📄", link: "", group: "Self Assesment" },
    { label: "AI Insights", emoji: "🤖📊", link: "", group: "Self Assesment" },

      // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/bankwala-bookworld", group: "Micro-Earning" },
    { label: "ValueShare", emoji: "💾", link: "/orderflow-earning-estimator", group: "Micro-Earning" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Micro-Earning" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Micro-Earning" },
    { label: "Rewarding Videos", emoji: "🎥🌾", link: "/orderflow-spotbuy", group: "Micro-Earning" },
    
    // 📚 Continous Banking Learning
    { label: "BankWala Learning", emoji: "🗓️", link: "/bankwala-bookworld", group: "Continous Banking Learning" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Continous Banking Learning" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Continous Banking Learning" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Continous Banking Learning" },
    { label: "bankTube", emoji: "️▶️", link: "/banktube", group: "Continous Banking Learning" },

    // ⚡ Productivity
    { label: "TRACK", emoji: "🚦", link: "/bankwala-track", group: "Productivity" },    
    { label: "DeepThinking Lab", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Productivity" },
    { label: "Minutes of Meeting", emoji: "📝", link: "/tasks/add", group: "Productivity" },
    { label: "Goal Board", emoji: "🎯", link: "/bankwala-goalboard", group: "Productivity" },
    { label: "Kanban", emoji: "🗂️", link: "/bankwala-kanban", group: "Productivity" },
    { label: "TrackBuddy AI", emoji: "🔷", link: "/trackbuddy", group: "Productivity" },
    { label: "Consulting", emoji: "👨‍💼", link: "/think5whys-counsellors", group: "Productivity" },

    // 📝 FinEx
    { label: "FinEx", emoji: "📝", link: "/bankwala-bookworld", group: "FinEx" },    

    // 👳 FINWISER
    { label: "FINWISER", emoji: "👳", link: "/finwiserdashboard", group: "FINWISER" },  
    
    // 🛡️ FinTrust
    { label: "FinTrust", emoji: "🛡️", link: "/fintrustaiabout", group: "FinTrust" },  

    // ⚙️ Processifyd
    { label: "Processifyd", emoji: "⚙️", link: "/Processifyd-home", group: "Processifyd" },  

    // 🔄 Banker Self Reflection
    { label: "BankWala Ranking", emoji: "🏆", link: "/bankwalascore", group: "Banker Self Reflection" },
    { label: "SAKSHAM BankWala", emoji: "💾", link: "/bankwaladb", group: "Banker Self Reflection" },
    { label: "AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Banker Self Reflection" },    
    { label: "Digital Card", emoji: "📘", link: "/digitalcard", group: "Banker Self Reflection" },
    { label: "Self Management", emoji: "🙋‍♀️", link: "/bankwala-self-chronicles", group: "Banker Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Banker Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Banker Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/bankwala-focustimerstart", group: "Banker Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Banker Self Reflection" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Banker Self Reflection" },

    // 🛍️ Other Engagements
    { label: "Marketplace", emoji: "🏪", link: "/orderflow-home", group: "Other Engagements" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Other Engagements" },
    { label: "BankWala MetaVerse", emoji: "🕶️", link: "/bankwala-metaverse", group: "Other Engagements" },
    { label: "BankWala Games", emoji: "🎮", link: "/bankwala-games", group: "Other Engagements" },

    // BankWala AI
    { label: "Ask Thinky", emoji: "👳", link: "/agenticsim", group: "BankWala AI" },
    { label: "FinTrust AI", emoji: "🛡️", link: "/fintrustaiabout", group: "BankWala AI" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl font-bold text-yellow-300">🏦 BankWala</div>
          <div className="text-[11px] lg:text-lg text-white">Better Actions Now. Keep Working Accountably. Learning Always</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 font-medium">Welcome, {userName}</div>
              <div className="flex gap-3">
                 <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">Login</Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links (desktop + mobile inline area) */}
      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/bankwala-why" className="hover:text-yellow-200">💭 About BankWala</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/bankwala-faq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
      </div>

      {/* Tabs (categories) */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main content area with grid of buttons */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BankWalaHome;
